import React from 'react';

import ALink from '~/components/features/custom-link';
import { usesBrandAccent } from '~/utils/programAccent';
import styles from './category-card.module.scss';

// Card de categoria compartida entre el landing de /shop y la seccion de
// categorias del home. Gradientes de acento SOLO para el recuadro del icono.
export const CATEGORY_ACCENTS: [string, string][] = [
  ['#6d5efc', '#b45be0'],
  ['#00b4d8', '#0077b6'],
  ['#f59e0b', '#ef4444'],
  ['#10b981', '#059669'],
  ['#ec4899', '#8b5cf6'],
  ['#3b82f6', '#06b6d4'],
  ['#f43f5e', '#f59e0b'],
  ['#8b5cf6', '#6366f1'],
];

const FALLBACK_ICON = 'fas fa-gift';

// Los programas con acento de marca no usan la paleta de colores: todas las
// categorías van con el color del programa, que llega por variable CSS.
const PROGRAM_ACCENT: [string, string] = [
  'var(--store-accent, #6d5efc)',
  'var(--store-accent-2, #b45be0)',
];

export const catAccent = (i: number): [string, string] =>
  usesBrandAccent() ? PROGRAM_ACCENT : CATEGORY_ACCENTS[i % CATEGORY_ACCENTS.length];

const grad = (i: number) => {
  const [from, to] = catAccent(i);
  return `linear-gradient(135deg, ${from}, ${to})`;
};

export type CategoryCardData = {
  id: number;
  name: string;
  icon?: string;
  productCount?: number;
};

export function CategoryCard({ cat, i }: { cat: CategoryCardData; i: number }) {
  const [from, to] = catAccent(i);
  return (
    <ALink
      href={`/shop?category=${cat.id}`}
      className={styles.card}
      style={
        {
          '--accent-from': from,
          '--accent-to': to,
        } as React.CSSProperties
      }
    >
      <span className={styles.iconTile} style={{ backgroundImage: grad(i) }}>
        <i className={cat.icon || FALLBACK_ICON}></i>
      </span>
      <span className={styles.body}>
        <span className={styles.name}>{cat.name}</span>
        {cat.productCount ? (
          <span className={styles.count}>{cat.productCount.toLocaleString('es')} premios</span>
        ) : null}
      </span>
      <i className={`fas fa-arrow-right ${styles.go}`}></i>
    </ALink>
  );
}

export function AllCard({ href = '/shop?all=1&random=1' }: { href?: string }) {
  return (
    <ALink href={href} className={`${styles.card} ${styles.allCard}`}>
      <span className={`${styles.iconTile} ${styles.allIcon}`}>
        <i className="fas fa-th-large"></i>
      </span>
      <span className={styles.body}>
        <span className={styles.name}>Ver todos</span>
        <span className={styles.count}>Todo el catálogo</span>
      </span>
      <i className={`fas fa-arrow-right ${styles.go}`}></i>
    </ALink>
  );
}
